(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-contact"]) return;
  try {
    
  document.querySelector('.main-contact__status')?.focus();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-customer-addresses"]) return;
  try {
    
  if (!customElements.get('hsc-address-form')) {
    customElements.define('hsc-address-form', class extends HTMLElement {
      connectedCallback() {
        this.country = this.querySelector('[data-country]');
        this.province = this.querySelector('[data-province]');
        this.provinceField = this.querySelector('[data-province-field]');
        this.onChange = () => this.fillProvinces();
        this.onCancel = () => { const d = this.closest('details'); if (d) { d.open = false; d.querySelector('summary')?.focus(); } };
        if (this.country) {
          const def = this.country.dataset.default;
          if (def) {
            const opt = [...this.country.options].find((o) => o.value === def || o.textContent.trim() === def);
            if (opt) this.country.value = opt.value;
          }
          this.country.addEventListener('change', this.onChange);
          this.fillProvinces(this.province?.dataset.default);
        }
        this.cancelBtn = this.querySelector('[data-address-cancel]');
        this.cancelBtn?.addEventListener('click', this.onCancel);
      }
      disconnectedCallback() {
        this.country?.removeEventListener('change', this.onChange);
        this.cancelBtn?.removeEventListener('click', this.onCancel);
      }
      fillProvinces(selected) {
        if (!this.province) return;
        const opt = this.country.options[this.country.selectedIndex];
        let list = [];
        try { list = JSON.parse(opt?.dataset.provinces || '[]'); } catch (e) { list = []; }
        this.province.replaceChildren(...list.map(([value, label]) => new Option(label, value)));
        if (selected) {
          const match = list.find(([value, label]) => value === selected || label === selected);
          if (match) this.province.value = match[0];
        }
        if (this.provinceField) this.provinceField.hidden = list.length === 0;
        this.province.disabled = list.length === 0;
      }
    });
  }
  document.addEventListener('submit', (event) => {
    const form = event.target.closest('.main-customer-addresses__delete');
    if (form && !window.confirm(form.dataset.confirm)) event.preventDefault();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews-widget"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('hsc-review-loader')) return;
    class HscReviewLoader extends HTMLElement {
      connectedCallback() {
        this.tpl = this.querySelector('template[data-review-template]');
        this.slotEl = this.querySelector('[data-review-slot]');
        this.loaded = !this.tpl;
        if (this.tpl) {
          if ('IntersectionObserver' in window) {
            this.io = new IntersectionObserver((entries) => {
              if (entries.some((entry) => entry.isIntersecting)) this.load();
            }, { rootMargin: '600px 0px' });
            this.io.observe(this);
          } else {
            this.load();
          }
        }
        if (this.hasAttribute('data-write-selector')) {
          this.scope = this.closest('.reviews-widget') || this;
          this.onClick = (event) => {
            const button = event.target.closest('[data-review-write]');
            if (!button || !this.scope.contains(button)) return;
            event.preventDefault();
            this.load();
            this.openForm();
          };
          this.scope.addEventListener('click', this.onClick);
          this.onHash = () => { if (window.location.hash === '#Reviews') this.load(); };
          window.addEventListener('hashchange', this.onHash);
          this.onHash();
        }
      }
      disconnectedCallback() {
        if (this.io) this.io.disconnect();
        if (this.ro) this.ro.disconnect();
        if (this.scope && this.onClick) this.scope.removeEventListener('click', this.onClick);
        if (this.onHash) window.removeEventListener('hashchange', this.onHash);
        clearTimeout(this.timer);
        clearTimeout(this.pendingTimer);
      }
      load() {
        if (this.loaded || !this.tpl || !this.slotEl) return;
        this.loaded = true;
        if (this.io) this.io.disconnect();
        const wrap = document.createElement('div');
        wrap.className = 'reviews-widget__app-content';
        wrap.appendChild(document.importNode(this.tpl.content, true));
        this.slotEl.replaceChildren(wrap);
        const done = () => {
          this.slotEl.classList.remove('is-pending');
          if (this.ro) this.ro.disconnect();
        };
        if ('ResizeObserver' in window) {
          this.ro = new ResizeObserver(() => { if (wrap.offsetHeight > 60) done(); });
          this.ro.observe(wrap);
        }
        this.pendingTimer = setTimeout(done, 4000);
      }
      openForm() {
        const selector = this.dataset.writeSelector;
        let tries = 0;
        const attempt = () => {
          let target = null;
          if (selector) {
            try { target = this.querySelector(selector) || document.querySelector(selector); } catch (error) { target = null; }
          }
          if (target) { target.click(); return; }
          tries += 1;
          if (tries < 20) { this.timer = setTimeout(attempt, 150); return; }
          const HSC = window.HSC;
          if (HSC && HSC.scrollToTarget) HSC.scrollToTarget(this);
          else this.scrollIntoView();
        };
        attempt();
      }
    }
    customElements.define('hsc-review-loader', HscReviewLoader);
  })();

  } catch(e) { console.error(e); }
})();
})();
